// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2D7ib","value":"style_value__X6kaI","name":"style_name__yjbHR"};